import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const fetchInvitedOrgMembersTE = <E = CF.API.ApiError>(
  { orgId }: { orgId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListInvitedOrgMembersResponse> =>
  fetchTE<CF.API.Organizations.ListInvitedOrgMembersResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/invitations`,
    },
    onRejected,
  );
